import { authService as i } from "./service.es.js";
const t = () => {
  const e = i.getStorageTokens();
  return e != null && e.accessToken ? [i.isTokenValid(e.accessToken, 600), e] : [!1, void 0];
};
export {
  t as getValidTokens
};
